<template>
  <v-btn stacked href="/quotebuilder/checkout">
    <v-badge
      :color="this.color"
      :content="this.count"
      class="me-4"
    >
      <v-icon :icon="this.$cart_icon" class="text-black" size="x-large" />
    </v-badge>
  </v-btn>
</template>

<script>
export default {
  name: "cartComponent.vue",
  data(){
    return {
      count: 0,
      color: 'grey',
    };
  },
  watch:{
  },
  mounted() {
    this.getResults();
  },
  methods: {
    getResults() {
      let quote = [];
      const storedQuote = localStorage.getItem("quote");
      if(storedQuote) {
        quote = JSON.parse(storedQuote);
      }

      this.count = quote.length;

      if(this.count >> 0){
        this.color = this.$primary_color;
      }
    },
  },
}
</script>

<style scoped>

</style>